import { makeAutoObservable } from "mobx";
import { User } from "../models/User";
import { UNKNOWN_USER } from "../models/Invoice";

/**
 * Lightweight store for current user state.
 * Separated from UserStore to avoid circular dependencies.
 * UserStore updates this when the current user changes.
 */
class CurrentUserStore {
	user: User | undefined = undefined;

	constructor() {
		makeAutoObservable(this);
	}

	setUser(user: User | undefined) {
		this.user = user;
	}

	get userId(): string {
		return this.user?.id ?? UNKNOWN_USER;
	}

	get isAuthenticated(): boolean {
		return !!this.user;
	}
}

export const currentUserStore = new CurrentUserStore();
